import { TableComment } from "../../../general/src/TableComment";
import { TableContact } from "../../../general/src/TableContact";
import { TableDirectDeposit } from "../TableDirectDeposit";
import { DataHeader, DataSource, Layout, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFactoringCompany extends Layout {
    dataheaderFactoringCompany: DataHeader;
    layoutTableComment: TableComment;
    layoutTableContact: TableContact;
    layoutTableDirectDeposit: TableDirectDeposit;
    sourceComments: DataSource;
    sourceContact: DataSource;
    sourceDirectDeposit: DataSource;
    sourceFactoringCompany: DataSource;
    switchActive: Switch;
    switchFreezePay: Switch;
    tabComments: Tab;
    tabContacts: Tab;
    tabDirectDeposit: Tab;
    tabGeneral: Tab;
    tabsetGeneral: Tabset;
    textboxAchBatchClassCode: Textbox;
    textboxAddress: Textbox;
    textboxCity: Textbox;
    textboxEmail: Textbox;
    textboxExternalXref: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPhoneNumber: Textbox;
    textboxState: Textbox;
    textboxZipCode: Textbox;
}
